import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'
import { UserType } from '~/types/user-info-types'

export enum Tab {
  PERSONAL_INFO,
  PROFILE,
  AVATAR_NICKNAME,
  ONBOARDING_EMAIL,
  CHANGE_PASSWORD,
  CURRICULUM,
}

export interface SettingsFields {
  email: string
  nickname: string
  country: string
  curriculum: string
  birthYear: string
  phone: string
  wantsNewsletter: boolean

  userType: UserType | string
  skill: string
  yearsInSchool: string
  gradeLevelId: string

  currPassword: string
  newPassword: string
  newPasswordConfirm: string
}

export enum BackendError {
  INCORRECT_PASSWORD = 'incorrect_password',
  INVALID_EMAIL = 'invalid_email',
  UNKNOWN = 'unknown',
}

export type SettingsErrors = {
  [T in keyof SettingsFields as string]?: string
}

export enum ApiCall {
  UPDATE_USER_DATA,
  CHANGE_PASSWORD,
}

export interface SettingsState {
  errors: SettingsErrors
  fields: SettingsFields
  serverError: BackendError | null
  isServerErrorInNicknameTab: boolean | null
  tab: Tab | null
}

export interface UpdateUserDataReqFields {
  email: string
  nickname: string
  country: string
  curriculumCountryCode: CurriculumCountryCodes
  /** US state code or 'OTHER'. */
  curriculumStateCode: string
  birthYear: number | null
  wantsNewsletter: boolean
  phone: string

  userType: UserType | string
  skill: string
  yearsInSchool: number | null
  gradeLevelId: number | null

  currPassword: string
  newPassword: string
  newPasswordConfirm: string

  otherOnboardingSteps: {
    [key: string]: boolean
  }
}

export interface UpdateUserDataReqPayload {
  id: number
  data: Partial<UpdateUserDataReqFields>
}

export interface ChangePasswordReqPayload {
  currentPassword: string
  password: string
}

export type ReqBodyPayloadType = UpdateUserDataReqPayload | ChangePasswordReqPayload
